import { createContext } from 'react';

/**
 * The accent hue for the surrounding portal. The user app is sky; the admin
 * portal is amber. Shared components (e.g. Button) read this so a primary
 * action renders in the right accent without each call site opting in.
 *
 * Defaults to 'sky' so any component used outside a provider (the entire user
 * app) keeps the standard accent. `AdminLayout` provides 'amber'.
 */
export type PortalAccent = 'sky' | 'amber';

export const PortalAccentContext = createContext<PortalAccent>('sky');
